import { render, staticRenderFns } from "./ViewTheme.vue?vue&type=template&id=4edfc006&scoped=true&"
import script from "./ViewTheme.vue?vue&type=script&lang=js&"
export * from "./ViewTheme.vue?vue&type=script&lang=js&"
import style0 from "./ViewTheme.vue?vue&type=style&index=0&id=4edfc006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edfc006",
  null
  
)

export default component.exports